$(document).on('click', '.mdw_close', function (e) {
  e.preventDefault();
  e.stopPropagation();

  var summary = $('#Details-menu-drawer-container > summary')[0];
  if (summary) summary.click();
});

// keyboard support (div isn't natively focusable)
$(document).on('keydown', '.mdw_close', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    $(this).trigger('click');
  }
});


class SortDropdown extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.sort-dropdown__toggle');
    this.list = this.querySelector('.sort-dropdown__list');
    this.native = this.querySelector('.sort-dropdown__native');
    this.valueEl = this.querySelector('.sort-dropdown__value');
    this.options = Array.from(this.querySelectorAll('.sort-dropdown__option'));

    this.$list = $(this.list);
    this.speed = 250;

    // hand control of display over to jQuery
    this.list.hidden = false;
    this.$list.hide();

    this.toggle.addEventListener('click', () => this.setOpen(!this.isOpen));
    this.options.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));

    this.onDocClick = (e) => { if (!this.contains(e.target)) this.setOpen(false); };
    document.addEventListener('click', this.onDocClick);
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { this.setOpen(false); this.toggle.focus(); }
    });
  }

  disconnectedCallback() { document.removeEventListener('click', this.onDocClick); }

  get isOpen() { return this.toggle.getAttribute('aria-expanded') === 'true'; }

  setOpen(open) {
    if (open === this.isOpen) return;           // ignore redundant closes
    this.toggle.setAttribute('aria-expanded', open);

    if (open) {
      this.$list.stop(true, true).slideDown(this.speed);
    } else {
      this.$list.stop(true, true).slideUp(this.speed);
    }
  }

  select(btn) {
    this.options.forEach((o) => {
      const selected = o === btn;
      o.classList.toggle('is-selected', selected);
      o.setAttribute('aria-selected', selected);
    });
    this.valueEl.textContent = btn.textContent.trim();
    this.native.value = btn.dataset.value;
    this.setOpen(false);
    this.native.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
customElements.define('sort-dropdown', SortDropdown);


// Notify Me popup (app): it blocks a blank or invalid email but only outlines the field red,
// so spell out why underneath it. Same email rule the app checks against.
var nmEmailPattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

function nmEmailError(value) {
  value = $.trim(value);
  if (!value) return 'Please enter your email address.';
  if (!nmEmailPattern.test(value)) return 'Please enter a valid email address.';
  return '';
}

function nmShowEmailError() {
  var $input = $('#nm-email-input');
  if (!$input.length) return;

  var $msg = $input.siblings('.nm-email-error');
  if (!$msg.length) {
    $msg = $('<p class="nm-email-error" id="nm-email-error" role="alert"></p>').insertAfter($input);
    $input.attr('aria-describedby', 'nm-email-error');
  }
  var error = nmEmailError($input.val());
  $msg.text(error);
  $input.attr('aria-invalid', error ? 'true' : 'false');
}

// capture phase: the app's own submit handler stops the event from bubbling
document.addEventListener('click', function (e) {
  if (e.target.closest('#nm-form-container .nm-button button')) nmShowEmailError();
}, true);
document.addEventListener('keydown', function (e) {
  if (e.key === 'Enter' && e.target.id === 'nm-email-input') nmShowEmailError();
}, true);
// once a message is showing, keep it in step with what is typed
document.addEventListener('input', function (e) {
  if (e.target.id === 'nm-email-input' && $(e.target).siblings('.nm-email-error').text()) nmShowEmailError();
}, true);


if (window.scrollY > 10) {
   $('.template_index').addClass('header_bg');
} else {
   $('.template_index').removeClass('header_bg');
}



var adult = {
  all_option: function(){
    $('.footer-block__heading').on('click', function(){
      if ($(window).width() < 1025) {
        $(this).toggleClass('active');
        $(this).next('.footer-block__details-content').slideToggle();
      }
    });
  },
  homepage: function(){
    
  }
} 

$(function(){
  adult.all_option();
  adult.homepage();
});